import React from "react";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Link, StaticQuery } from "gatsby";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { graphql } from "gatsby";

const MarketingBanner = ({ content, classes, url }) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const { frontmatter } = content.allMarkdownRemark.edges[0].node;

  const handleOpenModal = () => {
    window.dispatchEvent(new Event("openClosingAnnouncement"));
  };

  return (
    <React.Fragment>
      {mdUp ? (
        <div className={classes.bannerContainer}>
          <Typography
            component="h5"
            variant="h5"
            className={classes.bannerText}
          >
            {frontmatter.subtitle}
            {"    "}
            <Button
              className={classes.button}
              onClick={handleOpenModal}
              size="small"
              variant="text"
            >
              Read more
            </Button>
          </Typography>
        </div>
      ) : (
        <div className={classes.bannerContainer}>
          <div className={classes.link} onClick={handleOpenModal} style={{ cursor: "pointer" }}>
            {frontmatter.subtitle}
            <ArrowForwardIcon className={classes.arrow} />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

const MarketingBannerQuery = ({ classes, url }) => (
  <StaticQuery
    query={graphql`
      query MarketingBannerQuery {
        allMarkdownRemark(
          filter: { frontmatter: { key: { eq: "marketing" } } }
        ) {
          edges {
            node {
              frontmatter {
                description
                title
                subtitle
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <MarketingBanner content={data} url={url} classes={classes} />
    )}
  />
);

export default withStyles(styles)(MarketingBannerQuery);
